import apiClient from './apiClient';

export interface Document {
  id: number;
  document_name?: string;
  file_name?: string;
  entity_name?: string;
  module_type?: string;
  status?: string;
  validation_status?: string;
  is_deleted?: boolean;
  created_date?: string;
}

const archiveApi = {
  async getAllDocuments(): Promise<Document[]> {
    return apiClient.get('/archive/documents');
  },

  async getDocumentById(id: number): Promise<Document> {
    return apiClient.get(`/archive/documents/${id}`);
  },

  async getStats() {
    return apiClient.get('/archive/stats');
  },
};

export default archiveApi;
